/**************************************************************************************************/
/** @import Node Packages                                                                        **/
/**************************************************************************************************/
import ExcelJS from 'exceljs'
import FileSaver from 'file-saver'

/**************************************************************************************************/
/** @export Class @name ExcelBook                                                                **/
/**************************************************************************************************/
export class ExcelBook
{
	/*************************************************/
	/** @Properties                                 **/
	/*************************************************/
	private workbook: ExcelJS.Workbook

	/*************************************************/
	/** @Constructor                                **/
	/*************************************************/
	constructor()
	{
		this.workbook = new ExcelJS.Workbook()
		this.workbook.created = new Date()
	}

	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	public getWorkBook() : ExcelJS.Workbook
	{
		return this.workbook
	}

	public getWorkSheet(name: string) : ExcelJS.Worksheet
	{
		return this.workbook.getWorksheet(name)
	}

	public removeWorkSheet(workSheet: ExcelJS.Worksheet) : this
	{
		this.workbook.removeWorksheet(workSheet.id)
		return this
	}

	public async saveFileAsCSV(fileName: string) : Promise<void>
	{
		const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
		const buffer = await this.workbook.csv.writeBuffer()
		const blob = new Blob(['\uFEFF', buffer], { type: fileType })
		FileSaver.saveAs(blob, `${ fileName }.csv`)
	}

	public async saveFileAsXLSX(fileName: string) : Promise<void>
	{
		const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
		const buffer = await this.workbook.xlsx.writeBuffer()
		const blob = new Blob([buffer], { type: fileType })
		FileSaver.saveAs(blob, `${ fileName }.xlsx`)
	}

	public setCreator(creator: string) : this
	{
		this.workbook.creator = creator
		return this
	}

	public setLastModifiedBy(by: string) : this
	{
		this.workbook.lastModifiedBy = by
		return this
	}

	public setLastPrintedOn(date: Date) : this
	{
		this.workbook.lastPrinted = date
		return this
	}

	public setModifiedWhen(date: Date) : this
	{
		this.workbook.modified = date
		return this
	}
}